import request from '@/utils/request'

const contractApi = {
  trade_custom_reminder_template_list: '/trade/custom_reminder/template/',
  trade_custom_reminder_template_create: '/trade/custom_reminder/template/',
  trade_custom_reminder_template_read: '/trade/custom_reminder/template/',
  trade_custom_reminder_template_delete: '/trade/custom_reminder/template/',
  trade_custom_reminder_rule_list: '/trade/custom_reminder/rule/',
  trade_custom_reminder_rule_create: '/trade/custom_reminder/rule/',
  trade_custom_reminder_rule_update: '/trade/custom_reminder/rule/',
  trade_custom_reminder_rule_delete: '/trade/custom_reminder/rule/'
}

/**
 * 列表
 */
export function trade_custom_reminder_template_list (parameter) {
  return request({
    url: contractApi.trade_custom_reminder_template_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function trade_custom_reminder_template_create (parameter) {
  return request({
    url: contractApi.trade_custom_reminder_template_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 详情
 */
export function trade_custom_reminder_template_read (contract_id) {
  return request({
    url: contractApi.trade_custom_reminder_template_read + contract_id + '/',
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
/**
 * 删除
 */
export function trade_custom_reminder_template_delete (contract_id) {
  return request({
    url: contractApi.trade_custom_reminder_template_delete + contract_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 列表
 */
export function trade_custom_reminder_rule_list (parameter) {
  return request({
    url: contractApi.trade_custom_reminder_rule_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function trade_custom_reminder_rule_create (parameter) {
  return request({
    url: contractApi.trade_custom_reminder_rule_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 修改
 */
export function trade_custom_reminder_rule_update (parameter, id) {
  return request({
    url: contractApi.trade_custom_reminder_rule_update + id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}

/**
 * 删除
 */
export function trade_custom_reminder_rule_delete (id) {
  return request({
    url: contractApi.trade_custom_reminder_rule_delete + id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
